import { languageOptions } from '@app/constants';
import i18n from '@app/i18n';
import { QuestionTranslationView, TranslationGenerationType } from '@data/sdk/match';
import { AntdTooltip } from '@ui/components';

/** Only the language and how its text was made are read, so any translation record fits. */
type TranslationSource = Pick<QuestionTranslationView, 'generationType' | 'language'>;

export const getLanguageOptions = (translations?: TranslationSource[]) => {
  return languageOptions().map((lang) => {
    const generationType = translations?.find((el) => el.language === lang.value)?.generationType;
    const isAIGenerated = generationType === TranslationGenerationType.AiGenerated;
    const isAutoTranslated = generationType === TranslationGenerationType.AutoTranslated;
    return {
      label: (
        <div className="flex flex-nowrap gap-1 items-center">
          <span>{lang.label}</span>
          {isAIGenerated && (
            <AntdTooltip title={i18n.t('common.ai_translation')}>
              <div className="h-fit px-[3px] py-[2px] border-solid border-inherit border-[1px] text-inherit rounded-full leading-none text-[10px]">
                AI
              </div>
            </AntdTooltip>
          )}
          {isAutoTranslated && (
            <AntdTooltip title={i18n.t('common.auto_translation')}>
              <div className="h-fit px-[3px] py-[2px] border-solid border-inherit border-[1px] text-inherit rounded-full leading-none text-[10px]">
                Auto
              </div>
            </AntdTooltip>
          )}
        </div>
      ),
      value: lang.value,
    };
  });
};
